/* eslint-env browser */

import React from 'react';

const PromoHeader = () => (
  <header className="promo-header promo-header--default promo-header--small" />
);

export default PromoHeader;
